import { supabase } from "@/integrations/supabase/client";

/**
 * Initiates a SellApp payment charge
 */
export const createCharge = async ({ email, total, currency, description, reference }) => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    
    const payload = {
      email,
      total, // Smallest unit (e.g., 1499 for $14.99)
      currency,
      description,
      reference,
      return_url: `${window.location.origin}/app?payment=success`,
      cancel_url: `${window.location.origin}/app?payment=cancelled`,
      payment_methods: ["PAYPAL"] // Restricted to PayPal as requested
    };

    const response = await fetch('https://hhvzikakktakbcdbaqxj.supabase.co/functions/v1/sellapp-payments', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session?.access_token}`,
      },
      body: JSON.stringify({ action: "create", payload })
    });

    const data = await response.json();
    if (data.error) throw new Error(data.error);
    
    return data; // Returns { id, url, status }
  } catch (error) {
    console.error("[SellApp Service] Create Charge Error:", error);
    throw error;
  }
};

/**
 * Checks the status of a specific charge
 */
export const getChargeStatus = async (chargeId) => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    
    const response = await fetch('https://hhvzikakktakbcdbaqxj.supabase.co/functions/v1/sellapp-payments', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session?.access_token}`,
      },
      body: JSON.stringify({ action: "get", chargeId })
    });

    const data = await response.json();
    if (data.error) throw new Error(data.error);
    
    return data;
  } catch (error) {
    console.error("[SellApp Service] Get Status Error:", error);
    throw error;
  }
};